import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import SelectBox from 'src/components/SelectBox';

const JobSurveysDropdown = ({ datasheets, onChange }) => {

  const surveyOptions = datasheets?.map(v => ({
    value: v.currentVersion.id,
    label: v.currentVersion.name,
    surveyData: v.currentVersion.survey.surveyData,
    jobId: v.currentVersion.survey.jobId,
    datasheetVersionId: v.currentVersion.survey.datasheetVersionId,
  }))
  .sort((a, b) => a.label > b.label ? 1 : -1);

  const [selectedSurvey, setSelectedSurvey] = useState(surveyOptions[0]);

  useEffect(() => {
    if(selectedSurvey) {
      onChange(selectedSurvey);
    }
  }, []);

  return (
    <SelectBox
      onChange={(survey) => {
        setSelectedSurvey(survey);
        onChange(survey);
      }}
      options={surveyOptions}
      value={surveyOptions.filter(survey => survey.value === selectedSurvey?.value)}
    />
  );

};

JobSurveysDropdown.defaultProps = {
  datasheets: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(JobSurveysDropdown);
